import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { IdentityBodyAssessMethod } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service';
import { IJsonApiResponse } from '@reg/shared/json-api/json-api.interface';

/**
 * Service to get Body Assessment Methods
 */
@Injectable()
export class IdentityBodyAssessMethodService {
    public static INCLUDE_BODY_ASSESS_MEASUREMENTS: string = 'bodyAssessmentMeasurements';

    private identityApiBaseUrl: string;

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
        this.identityApiBaseUrl = http.configService.getBaseConfig('identityApiBaseUrl');
    }

    /**
     * Get all team rosters
     */
    public getIndex(includes: string[] = null, queryParams: string[] = null): Observable<IdentityBodyAssessMethod[]> {
        const apiRequestUrl: string = this.getApiUrl(null, includes, queryParams);

        // Make the http request
        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const settings: IdentityBodyAssessMethod[] = [];
                const included: Object[] = response.included;

                const bodyData: any = response.data || [];
                for (const setting of bodyData) {
                    settings.push((new IdentityBodyAssessMethod()).deserialize(setting, included));
                }

                return settings;
            }));
    }

    /**
     * Get a single team roster
     */
    public get(
        bodyAssessMethodId: string,
        includes: string[] = null,
    ): Observable<IdentityBodyAssessMethod> {
        const apiRequestUrl: string = this.getApiUrl(bodyAssessMethodId, includes, null);

        // Make the http request
        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => (new IdentityBodyAssessMethod().deserialize(response))));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(bodyAssessMethodId: string, includes: string[], queryParams: string[] = null): string {
        let url: string = `${this.identityApiBaseUrl}/body-assessment-methods/`;

        if (bodyAssessMethodId) {
            url += bodyAssessMethodId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}

